/**
 * ****************************************************************************
 * @description     :   LeftMenu
 * @created at      :   2022/07/13
 * @created by      :   
 * @package         :   dailyreportsystem
 * @copyright       :   Copyright (c)
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import libraries
 */
// import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import SimpleBar from 'simplebar-react';
import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch } from "react-redux";
import Actions from '../../redux/report/actions';

/**
 * Import child components
 */
// import ProfileDropdown from './components/profile-dropdown';

/**
 * Component for menu on the left of template
 * -----------------------------------------
 * @author : create
 * @param  : {Object} props - Properties of this component
 * @access : public
 */
const LeftMenu = (props) => {
    const { menus, currentMenu } = props;
    const dispatch = useDispatch();
    const [startDate, setStartDate] = useState(new Date());
    const changeDate = (date) => {
        setStartDate(date);
        const condition = {};
        condition.date = date;
        dispatch(Actions.GetReports(condition));
    }

    return (
        <div className="nk-apps-sidebar is-dark">
            <div className="flex justify-between sm:justify-center items-center h-16 px-4">
                <div className="flex justify-center items-center">
                    <svg width="1.2em" height="1.2em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 448 512" className="w-6 h-6 mr-2">
                        <path d="M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm320-196c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM192 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM64 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z" fill="currentColor" />
                    </svg>
                    <span className="text-xl font-medium">カレンダー</span>
                </div>
            </div>
            <DatePicker selected={startDate} onChange={(date) => changeDate(date)} inline />
            <div className="nk-sidebar-element">
                <div className="nk-sidebar-body">
                    <SimpleBar className="nk-sidebar-content">
                        <div className="nk-sidebar-menu">
                            {/* Menu */}
                            <ul className="nk-menu apps-menu">
                                {menus.map((menu) => (
                                    <li
                                        key={menu.id}
                                        className={`${menu.type === "hr" ? "nk-menu-hr" : ""} ${
                                            menu.type === "menu" ? "nk-menu-item" : ""
                                        } ${currentMenu === menu.to ? "active curent-page" : ""}`}
                                    >
                                        {menu.type === "menu" &&
                                            (menu.to && menu.to.name !== "" ? (
                                                <Link
                                                    to={menu.to}
                                                    title={menu.title}
                                                    className="nk-menu-link"
                                                >
                                                    <span className="nk-menu-icon">
                                                        <em className={`icon ni ${menu.icon}`} />
                                                        {menu.title}
                                                    </span>
                                                </Link>
                                            ) : (
                                                <a
                                                    href="javascript:void(0);"
                                                    className="nk-menu-link"
                                                    title={menu.title}
                                                >
                                                    <span className="nk-menu-icon">
                                                        <em className={`icon ni ${menu.icon}`} />
                                                    </span>
                                                </a>
                                            ))}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </SimpleBar>
                </div>
            </div>
        </div>
    );
};

LeftMenu.propTypes = {
    menus: PropTypes.arrayOf(
        PropTypes.shape({
            type: PropTypes.string.isRequired,
            title: PropTypes.string,
            icon: PropTypes.string,
            to: PropTypes.string,
            header: PropTypes.shape({
                showLeftHeader: PropTypes.bool,
                dataTitle: PropTypes.shape({
                    icon: PropTypes.string,
                    subText: PropTypes.string,
                    leadText: PropTypes.string,
                }),
            }),
        })
    ),
    currentMenu: PropTypes.string,
};

LeftMenu.defaultProps = {
    menus: [],
    currentMenu: "/daily-report-system",
};
export default React.memo(LeftMenu);
